import React from "react";

import { map } from "@s-libs/micro-dash";
import PropTypes from "prop-types";

import RowHeading from "@/browse/RowHeading";
import CardFooter from "@/components/CardFooter";
import DeckOfCards from "@/components/DeckOfCards";
import SeeMore from "../SeeMore";
import { generateSeeMoreLink } from "../SeeMore/SeeMore.utils";
import { clipRowStyle, clipRowWrapperStyle } from "./ClipRow.style";

export const propTypes = {
  seeMoreMultiOrSingle: PropTypes.bool,
  rowData: PropTypes.object,
  streamProperties: PropTypes.object,
};

const defaultProps = {
  rowData: {},
};

/**
 * @param {object} rowData
 */

const generateRowElements = (
  { members, slug: parentSlug },
  streamProperties,
) => {
  const rowItems = map(members, (member, index) => {
    return (
      <DeckOfCards
        {...member}
        footer={
          <CardFooter
            contentId={member.content_id}
            contentType={member.content_type}
            recommendationSetIds={member.recommendation_set_ids}
            veil={member.veil}
            visibilityMarkers={member.visibility_markers}
          />
        }
        index={index}
        key={`${member}-${index}`}
        parentSlug={parentSlug}
        streamProperties={streamProperties}
        trackImpression
      />
    );
  });
  // Max number of cards rendered by ClipRow is 4
  return rowItems.slice(0, 4);
};

export const ClipRow = (props) => {
  const { rowData, streamProperties } = props;

  const { title } = rowData;

  const rowElements = generateRowElements(rowData, streamProperties);
  const seeMoreURL = generateSeeMoreLink(rowData);
  const MAX_ELEMENTS = 4;
  /* if there are fewer rowElements than the max, do not show 'See More'.
   * rowData with exactly the max number will show See More due to CSS
   * hiding the 4th one at a specific breakpoint.
   * In this case, 'See More' will still be visible
   * even though there is no more content at larger breakpoints
   */
  const showSeeMore = !(rowElements.length < MAX_ELEMENTS);

  return (
    <div css={clipRowWrapperStyle}>
      <RowHeading rowTitle={title} seeMoreURL={seeMoreURL} />
      <div css={clipRowStyle}>{rowElements}</div>
      {showSeeMore && <SeeMore seeMoreURL={seeMoreURL} rowTitle={title} />}
    </div>
  );
};

ClipRow.defaultProps = defaultProps;
ClipRow.propTypes = propTypes;
export default ClipRow;
